export default __webpack_public_path__ + "static/media/life-insurance.b3ab5b5a.png";